module.exports = __webpack_public_path__ + "img/AdelleSAGE.a3ce7744.svg";